import { render } from "./page_component.html?vue&type=template&id=022fedd1&external"
import script from "./page_component.js?vue&type=script&lang=js&external"
export * from "./page_component.js?vue&type=script&lang=js&external"

import "./PageComponent.vue?vue&type=style&index=0&id=022fedd1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__